<script setup lang="ts">
definePage({
  name: 'investing.entity-deals',
  // Retired surface (tickets/3216): the deal pipeline is the only deals
  // surface — a vehicle's raises surface by searching its name there. The
  // route name survives as a redirect contract for bookmarks: every
  // entity type (funds included) lands on its overview, never a dead
  // page.
  redirect: (to) => ({ name: 'investing.entity-overview', params: to.params }),
})
</script>

<template>
  <div />
</template>
